import React, { useEffect, useState, useRef, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'
import Tooltip from '@material-ui/core/Tooltip'
import CreditCard from '@material-ui/icons/CreditCardOutlined'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {makeStyles} from '@material-ui/styles'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFileInvoice, faFileInvoiceDollar, faReceipt} from '@fortawesome/free-solid-svg-icons'
import Table from 'components/Table'
import {
  accessIdSelector,
  appIdSelector,
  cpfCnpjSelector,
  isTourEnabledSelector,
  userSelectedSelector
} from 'modules/Login/selectors/user'
import {hide, set, setWithConfig} from 'layouts/actions'
import PaymentDialog from './components/PaymentDialog/index'
import DetailPayment from './components/DetailPayment'
import {isLoadingOpenedSelector, openedDataSelector} from './selectors/opened'
import {fetchOpened} from './actions'
import ReceiptDialog from '../components/ReceiptDialog'
import {MTableBodyRow} from 'material-table'
import {SnackBillet} from './components/SnackBillet'
import {FormattedMessage} from 'react-intl'
import {STYLE_CELLS} from '../constants/index'
import {isLoadingBilletSelector} from './selectors/billet'
import {billetRequest} from '../services/installment'
import {receiptPayment} from '../services/financial'
import {ERROR_UNEXPECTED} from 'utils/message'
import {apiAnalyticsValue} from 'utils/GTM/action'
import {OPENED, PAYMENT} from './constants'
import CustomCellHighlight from 'components/CustomCellHighlight'
import {isCardWay} from 'modules/Negotiation/Finance/utils'
import {apiResetAction} from 'utils/API/actions/status'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Box} from "@material-ui/core";
import {Timer3TwoTone, TimerTwoTone} from "@material-ui/icons";
import {isLoadingRegistrationSelector, registrationSelector} from "../PaymentTypes/selectors/registrations";
import {fetchRegistration} from "../PaymentTypes/services/registration";
import {useRecoilState, useSetRecoilState} from "recoil";
import {selectedMatriculaPortalState} from "../../../recoil/atoms/selectedMatriculaPortalState";
import {selectedCreditCardState} from "../../../recoil/atoms/selectedCreditCardState";
import {selectedMatriculaState} from '../../../recoil/atoms/selectedMatriculaState'
import {useRecoilValue} from "recoil";
import {unidadeGetResponseState} from "../../../recoil/atoms/unidadeGetResponseState";
import * as _blackListService from '../../../service/blacklist-service'
import blockedResourcesSystem from '../../../utils/blockedResourcesSystem';
import { blockedResourcesEntitiesValues } from '../../../utils/blockedResourcesEntities'
import * as _matricula from "../../../service/matricula-service";
import {Redirect} from "react-router-dom";
import {PATH_ROUTE} from "../../../routes";
import Alert from "@material-ui/lab/Alert";
import {loadedCreditCardsState} from "../../../recoil/atoms/loadedCreditCardsState";

const useStylesAccordion = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));


const useStyles = makeStyles({
  payButton: {
    width: 32,
    height: 32,
    padding: 5
  },
  payDiscount: {
    margin: 0,
    color: 'green',
    fontWeight: 500
  },
  accordionDetails: {
    display: 'block',
  }
})

const smColumns = (isSmall) => ([
  { title: 'Mês/Ano ', field: 'yearMonthFormatted', cellStyle: { width: isSmall ? '30%' : '10%', paddingRight: 30, paddingLeft: 0 }, customSort: (param1, param2) => Date.parse(param1.expirationdate) - Date.parse(param2.expirationdate) },
  { title: 'Vencimento', field: 'expirationdateFormatted', cellStyle: { width: isSmall ? '30%' : '10%', paddingLeft: 0, paddingRight: 30 }, customSort: (param1, param2) => Date.parse(param1.expirationdate) - Date.parse(param2.expirationdate) },
  { title: 'Valor no Vencimento', field: 'documentvalueFormatted', cellStyle: STYLE_CELLS, customSort: (param1, param2) => parseFloat(param1.documentvalue) - parseFloat(param2.documentvalue) }
])

const otherColumns = (classes) => ([
  { title: 'Fatura', field: 'invoice', cellStyle: STYLE_CELLS },
  { title: 'Parcelamento disponível', field: 'enables_installment_payment', render: row => row.enables_installment_payment ? `${row.maximum_installment_number} x` : '---', cellStyle: STYLE_CELLS },
])

const otherMediumColumns = () => ([
  // {title: 'Débito Automático', field: 'automaticdebitFormatted', cellStyle: STYLE_CELLS},
  {title: 'Aluno', field: 'studentnameFormatted', cellStyle: STYLE_CELLS},
  {
    title: 'Situação',
    field: 'paymentavailabilityFormatted',
    cellStyle: STYLE_CELLS,
    render: row => row.paymentavailabilityFormatted === 'Vencido' ? (
      <Box
        sx={{
          color: 'red',
          fontWeight: 'fontWeightBold',
          borderRadius: 16,
          border: '1px solid red',
          padding: '0px 8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <TimerTwoTone/> {row.paymentavailabilityFormatted}
      </Box>
    ) : row.paymentavailabilityFormatted,
  }
])

const SmallCircularProgress = () => (
  <span style={{fontSize: 18}}>
    <CircularProgress size={18}/>
  </span>)

const Action = ({ tooltip, className, value, onClick, icon: Icon, id, dataTur, loading, tableRef }) => {
  if (Array.isArray(value)) {
    return (
      <Tooltip title={tooltip}>
        <span>
          <Button
            size='small'
            data-tut={`${dataTur}-actions`}
            id={id}
            disabled={loading}
            onClick={ev => onClick(ev, value, id)}
            endIcon={loading ? <SmallCircularProgress /> : <Icon />}
            variant="contained"
            color="primary"
          >
            Pagar Selecionados
          </Button>
        </span>
      </Tooltip>
    )
  }

  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          size='small'
          data-tut={`${dataTur}-action`}
          className={className}
          id={id}
          disabled={(dataTur === 'tur-home-pay' && value.tableData.checked && tableRef.current?.dataManager?.selectedCount > 1) || loading}
          onClick={ev => onClick(ev, value, id)}
          aria-label='action'>
          {loading ? <SmallCircularProgress /> : <Icon />}
        </IconButton>
      </span>
    </Tooltip>
  )
}

const RenderAction = (value, tableRef) => act => {
  const { hidden, icon, onClick, tooltip, id, className, dataTur, loading } = act(value)

  if (hidden)
    return null

  return <Action
    dataTur={dataTur}
    key={id}
    icon={icon}
    onClick={onClick}
    tooltip={tooltip}
    id={id}
    loading={loading}
    className={className}
    value={value}
    tableRef={tableRef}
  />
}

const optionsColumn = (actions, tableRef) => ({
  title: 'Pagar',
  field: 'canPay',
  sorting: false,
  // usa a mesma logica das actions
  render: value => actions.map(RenderAction(value, tableRef)),
  cellStyle: { minWidth: 90, paddingBottom: 8, paddingTop: 8 }
})

const CustomAction = (props) => RenderAction(props.data, props.tableRef)(props.action)

const defaultReceipt = {open: false, correctvalue: 0}

const Pay = (isConfigure = false) => {
  const classes = useStyles()
  const tableRef = useRef()
  const dispatch = useDispatch()

  const [items, setItems] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [openModalReceipt, setOpenModalReceipt] = useState(defaultReceipt)
  const [showCreditCardBlocked, setShowCreditCardBlocked] = useState(true);
  const [showDebitCardBlocked, setShowDebitCardBlocked] = useState(true);
  const [hideCardOption, setHideCardOption] = useState(false);
  const [loaddingActions, seLoadingActions] = useState([])
  const [isFirst, setIsFirst] = useState(true)

  const isTourOpen = useSelector(isTourEnabledSelector)
  const appid = useSelector(appIdSelector)
  const accessId = useSelector(accessIdSelector)
  const cpfCnpj = useSelector(cpfCnpjSelector)
  const data = useSelector(openedDataSelector)
  const openedThisYear = useMemo(() => (data || []).filter(item => parseInt(item.expirationdate.split('-')[0]) >= new Date().getFullYear()), [data]);
  const opened = useMemo(() => (data || []).filter(item => parseInt(item.expirationdate.split('-')[0]) < new Date().getFullYear()), [data]);
  const isLoadingData = useSelector(isLoadingOpenedSelector)
  const isLoadingBillet = useSelector(isLoadingBilletSelector)
  const [blockedResources, setBlockedResources] = useState([])
  const [matriculasByResponsavel, setMatriculasByResponsavel] = useState([])
  const [isLoadingBlockedResources, setIsLoadingBlockedResources] = useState(true)
  const userSelected = useSelector(userSelectedSelector)
  const [isLoadingReceipt, setLoading] = useState(false)
  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const isMedium = useMediaQuery(theme => theme.breakpoints.down('md'))
  const {data: registrationData} = useSelector(registrationSelector)
  const isLoading = useSelector(isLoadingRegistrationSelector)
  const setSelectedMatriculaPortal = useSetRecoilState(selectedMatriculaPortalState)
  const setSelectedMatricula = useSetRecoilState(selectedMatriculaState)
  const setSelectedCard = useSetRecoilState(selectedCreditCardState);
  const classesAccordion = useStylesAccordion()
  const [viewLock, setViewLock] = useState({})
  const [unidade, setUnidade] = useRecoilState(unidadeGetResponseState)
  
  const title = isSmall
    ? 'Parcelas vencidas'
    : 'Parcelas com vencimento próximo ou vencidas'

  const setMessage = (message) => dispatch(message ? set(message) : hide())

  React.useEffect(() => {
    if (data && data.length === 0) {
      dispatch(fetchRegistration(appid, accessId))
    }
  }, [data, dispatch, appid, accessId])

  useEffect(() => {
    if (isFirst) {
      cleanSelection()
      setIsFirst(false)
      if (!isTourOpen) {
        dispatch(apiResetAction(OPENED))
      }
      return
    }
  }, [appid, isTourOpen, data])

    useEffect(() => {
      const fetchPaymentTypes = async () => {
          const idResponsavelCookie = sessionStorage.getItem("@SMO20/idResponsavel");
          let responseResult = await _matricula.GetbyMatriculasByResponsavel(idResponsavelCookie, false);

          if (responseResult && responseResult.value) {
            setMatriculasByResponsavel(responseResult.value);
          }
          if (!blockedResources || !blockedResources.length) {
              await _blackListService.GetBySistemaId(blockedResourcesSystem.SMO).then((response) => {
                  if (response && response.length) {
                      setBlockedResources(response)
                  }
                  setIsLoadingBlockedResources(false)
              }).catch(() => {
                  setIsLoadingBlockedResources(false)
              })
          }
      }
      fetchPaymentTypes();
    }, [])

  useEffect(() => {
    if (isTourOpen && !isEmpty(data)) {
      return
    }
    dispatch(fetchOpened({accessId, cpfCnpj}))
    cleanSelection()
  }, [accessId, dispatch, isTourOpen, userSelected])

  useEffect(() => {
    if (unidade && blockedResources && blockedResources.length) {
      const {id: idUnidade} = unidade
      const locksFiltered = blockedResources.filter(r => r?.unidadeId === idUnidade && r.type === blockedResourcesEntitiesValues.Unidade)
      if (locksFiltered) {
        const verifylock = (
          {
            lockName,
            action,
            setLock,
            defaultMessage,
            selectedYear
          }
        ) => {
          const lockFound = locksFiltered.find(x => x.action === action)
          if (lockFound) {
            setLock({
              [lockName]: true,
              [`${lockName}Message`]: lockFound?.mensagemBloqueio && lockFound?.mensagemBloqueio !== ''
                ? lockFound?.mensagemBloqueio
                : defaultMessage
            })
          } else {
            setLock({})
          }
        }

        verifylock({
          lockName: 'view',
          setLock: setViewLock,
          action: 'ParcelasAbertaPortal/Unidade',
          defaultMessage: 'Bloqueado para esta unidade',
        })
      }
    }
  }, [unidade, blockedResources])



  const CustomActions = (props) => {
    const selectedCount = props.data?.length > 0 ? props.data.filter(item => item.tableData?.checked).length : 0;

    const showMultiActions = selectedCount >= 2;
    const filteredActions = actions(props.components.isTourOpen, true).filter(action => {

      if (Array.isArray(props.data)) {
        return showMultiActions;
      }
      return true;
    });

    return (
      <div data-tut='tur-home-actions' style={{paddingLeft: 8}}>
        {filteredActions.map(RenderAction(props.data || []))}
      </div>
    );
  }

  const CustomRow = (props) => {
    const selected = (event, path, dataClicked) => {
      if (tableRef.current && tableRef.current?.unity === 0) {
        tableRef.current.unity = props.data.unityid
        tableRef.current.financialType = props.data.paymentWayId
      } else if (dataClicked.tableData.checked && tableRef.current?.dataManager?.selectedCount === 1) {
        cleanSelection()
      }
      props.onRowSelected(event, path, dataClicked)
    }
    return <MTableBodyRow {...props} onRowSelected={selected} data-tur='tut-row-opened'/>
  }

  const closeModal = () => {
    setOpenModal(false)
    setSelectedCard(null);
    dispatch(fetchOpened({ accessId, cpfCnpj }))
    cleanSelection()
  }

  const cleanSelection = () => {
    try {
      tableRef.current.unity = 0
      tableRef.current.financialType = undefined
    } catch (e) {
      console.error(e)
    }
  }

  const isHiddenAction = (rowData, isTour, isHeader, check) => {
    if (isTour) {
      return false
    }
    
    if (isHeader && Array.isArray(rowData) && rowData.some(item => item.tableData?.checked)) {
      return false;
    }
    
    if (!isHeader && !Array.isArray(rowData) && rowData.tableData) {
      const multipleRowsSelected = tableRef.current?.dataManager?.selectedCount > 1;
      if (multipleRowsSelected) {
        return true;
      }
      
      const anyRowSelected = tableRef.current?.dataManager?.selectedCount > 0;
      if (anyRowSelected && !rowData.tableData.checked) {
        return true;
      }
    }
    

    if (check === 'canPay') {
      if (isHeader && tableRef.current?.dataManager?.selectedCount === 1) {
        return true
    }


        if(isHeader && hideCardOption) return true
        const matriculaUnidade = matriculasByResponsavel.find(m => m.codigoMatriculaErp === rowData.registrationid);
        if (matriculaUnidade) {
            const locksFiltered = blockedResources.filter(r => r?.unidadeId === matriculaUnidade.unidade_Id && r.type === blockedResourcesEntitiesValues.Unidade);
            if (locksFiltered && locksFiltered.length) {
                const isCreditCardBlocked = locksFiltered.find(r => r?.action === "PagamentoPortal/Unidade/Metodo/CartaoDeCredito" && r?.anoLetivo === matriculaUnidade.anoLetivo_Name);
                if (isCreditCardBlocked)
                  setShowCreditCardBlocked(false);
                const isDebitCardBlocked = locksFiltered.find(r => r?.action === "PagamentoPortal/Unidade/Metodo/CartaoDeDebito" && r?.anoLetivo === matriculaUnidade.anoLetivo_Name);
                if (isDebitCardBlocked)
                  setShowDebitCardBlocked(false);
                if (isCreditCardBlocked && isDebitCardBlocked) {
                    setHideCardOption(true);
                    return true
                } else {
                    setHideCardOption(false);
                }
            }
        }
    }
    if (Array.isArray(rowData)) {
      return (isHeader && isEmpty(rowData)) || !rowData.some(item => item[check])
    }
    return (!rowData[check])
  }

  const isNegotiation = (rowData, isTour) => {
    if (isTour) {
      return false
    }
    if (Array.isArray(rowData)) {
      return rowData.some(item => item.paymentWayId && isCardWay(item.paymentWayId))
    }
    return rowData.paymentWayId && isCardWay(rowData.paymentWayId)
  }

  const actions = (isTour, isHeader) => {
    return [
      rowData => ({
        dataTur: 'tur-home-pay',
        hidden: isHiddenAction(rowData, isTour, isHeader, 'canPay'),
        icon: CreditCard,
        tooltip: 'Pagar',
        onClick: onPayClick,
        id: 'btn-home-cred-' + (isHeader ? 'header-' : (Array.isArray(rowData) ? '' : rowData.tableData.id)),
        className: classes.payButton
      }),
      rowData => ({
        dataTur: 'tur-home-bol',
        hidden: isHeader || isHiddenAction(rowData, isTour, isHeader, 'canPrint') || isNegotiation(rowData, isTour),
        loading: isLoadingBillet && (Array.isArray(rowData) || loaddingActions === rowData.journaltransrecid),
        icon: () => <FontAwesomeIcon icon={faFileInvoiceDollar}/>,
        tooltip: 'Gerar Boleto',
        onClick: onDownloadBillet,
        id: 'btn-home-bol-' + (Array.isArray(rowData) ? '' : rowData.tableData.id),
        isFreeAction: false,
        className: classes.payButton,
      }),
      rowData => ({
        dataTur: 'tur-home-copy',
        hidden: isHeader || isHiddenAction(rowData, isTour, isHeader, 'canPrint') || isNegotiation(rowData, isTour),
        loading: isLoadingBillet && (Array.isArray(rowData) || loaddingActions === rowData.journaltransrecid),
        icon: () => <FontAwesomeIcon icon={faFileInvoice}/>,
        tooltip: 'Copiar Linha Digitável',
        onClick: onCopylineBillet,
        id: 'btn-home-copy-' + (Array.isArray(rowData) ? '' : rowData.tableData.id),
        isFreeAction: false,
        className: classes.payButton,
      }),
      rowData => ({
        dataTur: 'tur-home-receipt',
        hidden: isHeader || (!rowData.viewRecept && !isTour),
        loading: isLoadingReceipt && loaddingActions === rowData.journaltransrecid,
        icon: () => <FontAwesomeIcon icon={faReceipt} style={{width: 24, height: 24}}/>,
        tooltip: 'Comprovante',
        onClick: onReceipt,
        id: 'btn-gen-receipt-' + (Array.isArray(rowData) ? '' : rowData.tableData.id),
        isFreeAction: false,
        className: classes.payButton,
      }),
    ]
  }

  const columns = (isTour, isSmall) => {
    return [
      ...smColumns(isSmall),
      ...(isSmall ? [] : otherColumns(classes)),
      ...(isMedium ? [] : otherMediumColumns()),
      optionsColumn(actions(isTour, false), tableRef)
    ]
  }

  const onCopylineBillet = async (event, item, id) => {
    const items = Array.isArray(item) ? item : [item]

    const params = {
      appid,
      journaltransrecids: items.map(i => i.journaltransrecid),
      linhaDigitavel: "true"
    }

    if (!Array.isArray(item)) {
      seLoadingActions(item.journaltransrecid);
    }

    dispatch(billetRequest(params, cpfCnpj)).then(result => {
      const {fileurl: url, errors, linhadigitavelcopia} = result
      if (linhadigitavelcopia) {
        navigator.clipboard.writeText(linhadigitavelcopia);
        dispatch(set('Linha Digitável Copiada com sucesso!'));
      } else {
        dispatch(set('Erro ao copiar linha digitável!'));
      }
    })
  }

  const onDownloadBillet = async (event, item, id) => {
    const items = Array.isArray(item) ? item : [item]

    const params = {
      appid,
      journaltransrecids: items.map(i => i.journaltransrecid)
    }

    if (!Array.isArray(item)) {
      seLoadingActions(item.journaltransrecid)
    }

    dispatch(billetRequest(params, cpfCnpj)).then(result => {
      const {fileurl: url, errors} = result
      if (url) {
        const button = document.getElementById(id)
        const listener = () => {
          window.open(url, '_blank', 'noopener')
        }
        if (Array.isArray(item)) {
          dispatch(setWithConfig({
            customMessage: () => <FormattedMessage id='opened-payment-billet' values={{count: item.length}}/>,
            autoHideDuration: null,
            action: SnackBillet
          }))
        }

        button.addEventListener('click', listener, false)
        button.dispatchEvent(new CustomEvent('click'))
        button.removeEventListener('click', listener, false)
        seLoadingActions([])
      } else if (!isEmpty(errors)) {
        dispatch(set(errors[0].message))
      }
    })
  }

  const onPayClick = async (event, items) => {
    if (!Array.isArray(items)) {
      const registration = registrationData?.find(r => r.registrationid === items.registrationid);
      if (registration) {
        setSelectedMatriculaPortal(registration);
        setSelectedMatricula(matriculasByResponsavel.find(m => m.codigoMatriculaErp === items.registrationid));
      } else {
        setSelectedMatriculaPortal({
          registrationid: items.registrationid,
        });
        setSelectedMatricula(matriculasByResponsavel.find(m => m.codigoMatriculaErp === items.registrationid));
      }
    }
    dispatch(apiAnalyticsValue(PAYMENT, Array.isArray(items) ? items.length : 1))
    setItems(Array.isArray(items) ? items : [items])
    setSelectedCard(null);
    setOpenModal(true)
  }

  const onReceipt = async (event, item) => {

    seLoadingActions(item.journaltransrecid)
    setLoading(true)

    const params = {
      appId: appid,
      referenceId: item.referenceid,
      cpfCnpj: cpfCnpj,
      receiptNumber: item.receipt_number
    };

    dispatch(receiptPayment(params))
      .then(() => {
        setOpenModalReceipt({open: true, correctvalue: item.correctvalue})
        setLoading(false)
      })
      .catch(() => {
        dispatch(set(ERROR_UNEXPECTED))
        setLoading(false)
      })
  }

  const isNotSameUnity = (rowData) => {
    return tableRef.current && tableRef.current?.unity > 0 && rowData.unityid !== tableRef.current?.unity
  }

  const isNotSameAgreement = (rowData) => {
    if (tableRef.current) {
      return (tableRef.current?.financialType && rowData.paymentWayId !== tableRef.current.financialType)
        || (!tableRef.current?.financialType && rowData.paymentWayId && tableRef.current?.unity > 0)
    }
    return false
  }

  if (viewLock?.view) {
    return (
      <Alert severity="warning">
        {viewLock?.viewMessage}
      </Alert>
    )
  }

  return (
    <div data-tut='tur-table-pay'>
      <PaymentDialog
        open={openModal}
        showCreditCardOption={showCreditCardBlocked}
        showDebitCardOption={showDebitCardBlocked}
        items={items}
        onError={setMessage}
        onClose={closeModal}
      />
      <ReceiptDialog
        {...openModalReceipt}
        onClose={() => setOpenModalReceipt(defaultReceipt)}
      />
      <Table
        isLoading={isLoadingData || isLoading || isLoadingBlockedResources}
        tableRef={tableRef}
        components={{
          isTourOpen: isTourOpen,
          Action: CustomAction,
          Actions: CustomActions,
          Cell: (props) => <CustomCellHighlight {...props} tableref={tableRef}/>,
          Row: CustomRow,
          tableRef: tableRef
        }}
        options={{
          showTextRowsSelected: false,
          selectionProps: (rowData) => {
            return {
              'data-tut': 'tur-home-check-pay',
              disabled: !rowData.canPay || isNotSameUnity(rowData) || isNotSameAgreement(rowData),
              color: 'primary',
              id: 'pay-select-all-' + rowData.tableData.id,
              style: {padding: 0, maxWidth: '0.5em'}
            }
          },
          showSelectAllCheckbox: false,
          selection: false,
          headerStyle: {
            paddingRight: 1,
            padding: '16px 0px',
          }
        }}
        columns={columns(isTourOpen, isSmall)}
        data={openedThisYear}
        title={
          <Box
            sx={{
              paddingTop: 16,
              paddingBottom: 8
            }}
          >
            <Typography
              variant='h5'
              component='h6'
            >
              {title}
            </Typography>
          </Box>
        }
        detailPanel={[
          (rowData) => ({
            disabled: isTourOpen ? false : !rowData.billetDemonstrativeGroupDetails || rowData.billetDemonstrativeGroupDetails.itens.length === 0,
            tooltip: (rowData.billetDemonstrativeGroupDetails && rowData.billetDemonstrativeGroupDetails.itens.length > 0) || isTourOpen ? 'Detalhes' : '',
            render: rowData => <DetailPayment item={rowData}/>
          })
        ]}
      />

      {!isLoadingData && (
        <Box
          sx={{
            mt: 4
          }}
        >
          <Accordion
            defaultExpanded={openedThisYear?.length === 0}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classesAccordion.heading}>Parcelas de anos anteriores</Typography>
            </AccordionSummary>

            <AccordionDetails
              className={classes.accordionDetails}
            >
              <Table
                elevation={0}
                isLoading={isLoadingData}
                tableRef={tableRef}
                components={{
                  isTourOpen: isTourOpen,
                  Action: CustomAction,
                  Actions: CustomActions,
                  Cell: (props) => <CustomCellHighlight {...props} tableref={tableRef}/>,
                  Row: CustomRow
                }}
                options={{
                  showTextRowsSelected: false,
                  selectionProps: (rowData) => {
                    return {
                      'data-tut': 'tur-home-check-pay',
                      disabled: !rowData.canPay || isNotSameUnity(rowData) || isNotSameAgreement(rowData),
                      color: 'primary',
                      id: 'pay-select-all-' + rowData.tableData.id,
                      style: {padding: 0, maxWidth: '0.5em'}
                    }
                  },
                  showSelectAllCheckbox: false,
                  selection: true,
                  headerStyle: {
                    paddingRight: 1,
                    padding: '16px 0px',
                  },
                  showTitle: false,
                }}
                columns={columns(isTourOpen, isSmall)}
                data={opened}
                detailPanel={[
                  (rowData) => ({
                    disabled: isTourOpen ? false : !rowData.billetDemonstrativeGroupDetails || rowData.billetDemonstrativeGroupDetails.itens.length === 0,
                    tooltip: (rowData.billetDemonstrativeGroupDetails && rowData.billetDemonstrativeGroupDetails.itens.length > 0) || isTourOpen ? 'Detalhes' : '',
                    render: rowData => <DetailPayment item={rowData}/>
                  })
                ]}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </div>
  )
}

export default Pay